window.addEventListener('ig:ready', () => {

  window.intelligemsMeta = {
    experiment_id: '',
    test_name: '',
    variant_id: '',
    variant_name: ''
  };

  const intelligemsPayload = {
    experiment_id: [],
    test_name: [],
    variant_id: [],
    variant_name: []
  }

  const activeExperiments = window.igData?.user.getExperiments?.() || [];

  activeExperiments.forEach((exp) => {

    const testGroup = window.igData?.user.getTestGroup?.(exp.id);

    intelligemsPayload.experiment_id.push(exp.id)
    intelligemsPayload.test_name.push(exp.name)
    intelligemsPayload.variant_id.push(testGroup?.id || 'unassigned')
    intelligemsPayload.variant_name.push(testGroup?.name || 'unassigned')
    
  });

  intelligemsPayload.experiment_id = intelligemsPayload.experiment_id.toString()
  intelligemsPayload.test_name = intelligemsPayload.test_name.toString()
  intelligemsPayload.variant_id = intelligemsPayload.variant_id.toString()
  intelligemsPayload.variant_name = intelligemsPayload.variant_name.toString()

  window.intelligemsMeta = intelligemsPayload;

  if (!localStorage.getItem('intelligems_meta_synced')) {
    const intelligemsJSON = JSON.stringify(window.intelligemsMeta);

    fetch(`${Shopify.routes.root}cart/update.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        attributes: {
          intelligems_meta: intelligemsJSON
        }
      })
    })
      .then(res => res.json())
      .then(() => {
        localStorage.setItem('intelligems_meta_synced', 'true');
      })
      .catch((err) => {
        console.error('[Intelligems] Failed to update cart attribute:', err);
      });
  }
});
